import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { emailEditorChange } from 'actions/template'
import Editor from 'components/Editor'
// const Editor = require('components/Editor').default

export default connect(
  (state) => ({ value: state.email.body.value }),
  (dispatch) => bindActionCreators({ emailEditorChange }, dispatch),
)(({ value, emailEditorChange, borderRadius }) => {
  // if (borderRadius) {
  //   require('./borderRadius.css')
  // } else {
  //   require('./noBorderRadius.css')
  // }
  return <Editor value={value} onChange={emailEditorChange} />
})
